import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import classNames from 'classnames';
import Button from '../components/Button';
import EmailForm from '../components/EmailForm';
import { partnerResults } from '../utils/constants';

const ResultsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const resultsRef = useRef(null);
  const [showResults, setShowResults] = useState(false);
  const { t } = useTranslation();

  const { winningPattern, allAnswers } = location.state || {
    winningPattern: null,
    allAnswers: []
  };

  const result = partnerResults[winningPattern];

  useEffect(() => {
    if (!winningPattern) {
      navigate('/');
    }
  }, [winningPattern, navigate]);

  if (!result) return null;

  const resultActions = t(`quiz.results.${winningPattern}.actions`, {
    returnObjects: true
  });

  return (
    <>
      <h2 className="font-title text-3xl font-semibold">
        {t('results.title')} {t(`quiz.results.${winningPattern}.title`)}
      </h2>

      <EmailForm
        result={result}
        allAnswers={allAnswers}
        showResults={showResults}
        setShowResults={setShowResults}
      />

      <section
        className={classNames(
          'mt-10 max-w-2xl',
          showResults ? 'block' : 'hidden'
        )}
      >
        <div ref={resultsRef} className="flex flex-col gap-8">
          <div>
            <p className="mb-2 text-xl font-bold text-primary">
              {t(`quiz.results.${winningPattern}.subtitle`)}
            </p>
            <h3 className="mb-4 text-2xl font-bold text-gray1">
              {t(`quiz.results.${winningPattern}.whatHappeningTitle`)}
            </h3>
            <p className="whitespace-pre-line font-light leading-relaxed text-gray1">
              {t(`quiz.results.${winningPattern}.whatHappeningInfo`)}
            </p>
          </div>

          <div className="rounded-xl bg-gray-100 p-6">
            <h3 className="mb-4 text-2xl font-bold text-gray1">
              {t(`quiz.results.${winningPattern}.whyRepairsTitle`)}
            </h3>
            <p className="whitespace-pre-line font-light leading-relaxed text-gray1">
              {t(`quiz.results.${winningPattern}.whyRepairsInfo`)}
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-2xl font-bold text-gray1">
              {winningPattern === 'E'
                ? t('results.actionsTitlePreventive')
                : t('results.actionsTitle')}
            </h3>
            <div className="flex flex-col gap-4">
              {Array.isArray(resultActions) &&
                resultActions.map((action, index) => (
                  <div key={index} className="flex gap-3">
                    <div className="flex h-[24px] min-w-[24px] items-center justify-center rounded-full bg-primary text-sm font-bold text-white">
                      {index + 1}
                    </div>
                    <p className="font-light text-gray1">
                      <strong className="font-bold">{action.title}:</strong>
                      <br />
                      {action.text}
                    </p>
                  </div>
                ))}
            </div>
          </div>

          <div className="border-t pt-8">
            <h3 className="mb-4 text-2xl font-bold text-gray1">
              {t('results.wannaTransform')}
            </h3>
            <div className="mb-6 font-light text-gray1">
              <p>{t(`quiz.results.${winningPattern}.nextStep`)}</p>

              <div className="mt-4 flex gap-4  rounded-xl bg-gray-100 p-8">
                <img
                  src="https://themindessence.com/wp-content/uploads/2026/01/Anderson-Ana-retrato-1-1.jpg"
                  alt=""
                  className="size-16 rounded-full"
                />
                <div className="flex flex-col">
                  <p className="font-semibold">
                    <strong>Anderson Miranda</strong> &{' '}
                    <strong>Ana Luz Gardim</strong>
                  </p>
                  <p>{t('results.facilitators.description')}</p>
                  <div className="mt-2">
                    <a
                      href="https://wa.me/34650177631"
                      className="flex items-center gap-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                        alt=""
                        width="24"
                        height="24"
                        className="mt-1"
                      />
                      <strong>+34 650 177 631</strong>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <a
            href={result.calendlyLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="w-full sm:w-auto ">
              {t('results.bookButton')}
            </Button>
          </a>
          <p className="text-sm">{t('results.callInfo')}</p>

          <div className="mt-12 flex w-full justify-center border-t pt-8">
            <Button onClick={() => navigate('/')} variant="outline">
              {t('results.repeatButton')}
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResultsPage;
